import createTheme from '@mui/material/styles/createTheme';
import deepmerge from '@mui/utils/deepmerge';
import {LIGHT_THEME} from '@apps-common/ui-theme/Themes';

const grey = LIGHT_THEME.palette.grey;
export const lightGrey = grey[300];

const MuiButton = {
  styleOverrides: {
    sizeSmall: {
      // These are needed to match Figma
      paddingTop: 4,
      paddingBottom: 4,
      paddingRight: 10,
      paddingLeft: 10,
    },
    root: {
      whiteSpace: 'nowrap', // Don't let buttons wrap, it's unsightly
    },
  },
};

const MuiDialogTitle = {
  defaultProps: {
    variant: 'h5',
  },
};

const MuiDrawer = {
  styleOverrides: {
    paperAnchorDockedLeft: {borderRight: `solid 1px ${grey[200]}`},
  },
};

const MuiLink = {
  defaultProps: {
    color: 'textPrimary',
    variant: 'inherit',
    underline: 'always',
  },
  styleOverrides: {
    root: {cursor: 'pointer'},
    underlineAlways: {backgroundColor: 'transparent'},
  },
};

const MuiListItem = {
  styleOverrides: {
    root: {
      '&.Mui-selected, &.Mui-selected:hover': {
        backgroundColor: LIGHT_THEME.palette.primary.light,
      },
    },
    button: {
      '&:hover': {backgroundColor: LIGHT_THEME.palette.primary.lighter},
    },
    divider: {borderBottom: `solid 1px ${lightGrey}`},
  },
};

const MuiListItemIcon = {
  styleOverrides: {
    root: {minWidth: 32, color: grey[600]},
  },
};

const MuiPaper = {
  styleOverrides: {
    outlined: {border: `solid 1px ${grey[200]}`},
  },
};

const MuiSvgIcon = {
  styleOverrides: {
    colorDisabled: {color: grey[500]},
  },
};

export const theme = createTheme(
  deepmerge(LIGHT_THEME, {
    typography: {
      subtitle1: {
        fontWeight: 500,
      },
    },
    palette: {
      background: {
        default: LIGHT_THEME.palette.background.paper,
      },
    },
    components: {
      MuiButton,
      MuiDialogTitle,
      MuiDrawer,
      MuiLink,
      MuiListItem,
      MuiListItemIcon,
      MuiPaper,
      MuiSvgIcon,
    },
  })
);
